(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-search"]) return;
  try {
    
  $(document).ready(function () {
    var productsHandle = [];
    setTimeout(function(){      
      $("ul.snize-search-results-content li a").each(function (n) {
        var productHdl = $(this).attr("href").slice(43);
        //console.log('pro564->',productHdl);
        productsHandle.push(productHdl);     
       console.log(productsHandle); 
      });
      $.each(productsHandle,function(i,product_handle){
        //console.log('pro111->',product_handle);
        
        $.getJSON('/products/'+product_handle+'.js', function(response) { 
          var des = response.description;

          var split_des = des.split("***");
          $('.search_download.search_pdf').append(split_des[4]);
        });
      });
    }, 3000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-custom-collection"]) return;
  try {
    
   var collTag;
   var collTaglist = [];

   $('input[type="checkbox"]').click(function(){
    collTag =  $(this).val().trim();

    if($(this).prop("checked") == true){
      collTaglist.push(collTag);
      <!-- console.log('collTaglistpush',collTaglist); -->

    $('.productgrid--items .product_data_list').removeClass('inactiveProduct');
    $('.productgrid--items .product_data_list').removeClass('activeProduct');

      $(".productgrid--items .product_data_list").each(function() {
          var proTags = $(this).attr('data-tags');
          proTags = proTags.split(',').map(val => val.trim());
          let isFound = collTaglist.every(pt => proTags.includes(pt));
          if(isFound){
            $(this).addClass('activeProduct');
          }
          else {
          $(this).addClass('inactiveProduct');
          }
      });
    }
    else if($(this).prop("checked") == false){
      $('.productgrid--items .product_data_list').removeClass('inactiveProduct');
    $('.productgrid--items .product_data_list').removeClass('activeProduct');

      collTaglist = jQuery.grep(collTaglist, function(value) {
        return value != collTag;
      });
      <!-- console.log('collTaglistpop',collTaglist); -->

      if (collTaglist.length === 0) {
        $(this).addClass('activeProduct');
    }
    else{
      $(".productgrid--items .product_data_list").each(function() {
        var proTags = $(this).attr('data-tags');
        proTags = proTags.split(',').map(val => val.trim());
        let isFound = collTaglist.every(pt => proTags.includes(pt));
        if(isFound){
          $(this).addClass('activeProduct');
        }
        else {
          $(this).addClass('inactiveProduct');
        }
      });
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
